import { AnyAction } from '@reduxjs/toolkit';
import { difference, union } from 'lodash';

// Usual actions are CRUD
export const BOOKMARK_ADD_PLACE = 'bookmarks/places/add';
export const BOOKMARK_DEL_PLACE = 'bookmarks/places/delete';
export const BOOKMARK_ADD_TRAIL = 'bookmarks/trails/add';
export const BOOKMARK_DEL_TRAIL = 'bookmarks/trails/delete';
export const BOOKMARK_ADD_STORIES = 'bookmarks/stories/add';
export const BOOKMARK_DEL_STORIES = 'bookmarks/stories/delete';
export const BOOKMARKS_RESET = 'bookmarks/reset';
export const BOOKMARKS_PLACES_RESET = 'bookmarks/places/reset';
export const BOOKMARKS_TRAILS_RESET = 'bookmarks/trails/reset';
export const BOOKMARKS_STORIES_RESET = 'bookmarks/stories/reset';

export type BookmarksPayload = {
	action_id?: number;
	places?: number[];
	trails?: number[];
	stories?: number[];
};

export type BookmarkReducerAction = {
	type: string;
	payload: BookmarksPayload;
};

const initialState: BookmarksPayload = {
	places: [],
	trails: [],
	stories: [],
};

export default function bookmarkReducer(
	state = initialState,
	action: AnyAction,
) {
	let new_state = Object.assign({}, state) as BookmarksPayload;

	switch (action.type) {
		case BOOKMARK_ADD_PLACE: {
			new_state.places = union(state.places, [action.payload.action_id]);
			return new_state;
		}
		case BOOKMARK_DEL_PLACE: {
			new_state.places = difference(state.places, [
				action.payload.action_id,
			]);
			return new_state;
		}
		case BOOKMARK_ADD_TRAIL: {
			new_state.trails = union(state.trails, [action.payload.action_id]);
			return new_state;
		}
		case BOOKMARK_DEL_TRAIL: {
			new_state.trails = difference(state.trails, [
				action.payload.action_id,
			]);
			return new_state;
		}
		case BOOKMARK_ADD_STORIES: {
			new_state.stories = union(state.stories, [
				action.payload.action_id,
			]);
			return new_state;
		}
		case BOOKMARK_DEL_STORIES: {
			new_state.stories = difference(state.stories, [
				action.payload.action_id,
			]);
			return new_state;
		}
		case BOOKMARKS_PLACES_RESET: {
			new_state.places = [];
			return new_state;
		}
		case BOOKMARKS_TRAILS_RESET: {
			new_state.trails = [];
			return new_state;
		}
		case BOOKMARKS_STORIES_RESET: {
			new_state.stories = [];
			return new_state;
		}
		case BOOKMARKS_RESET: {
			return initialState;
		}
		default:
			return state;
	}
}
